import React from 'react';

const ShowLengthCable = ({ isLineDrawing, lengthCable, lengthCableSegment }) => {
  if (isLineDrawing || lengthCable !== 0) {
    return (
      <div className="divCurrentLengthCable">
        <label style={{ color: '#ebebeb' }}>Длина кабеля: <span style={{ color: '#fcc205' }}>{lengthCable}  м.</span></label>
        <hr className='horizontalLineModalUpTer' />
        <label style={{ color: '#ebebeb' }}>Длина отрезка: <span style={{ color: '#fcc205' }}>{lengthCableSegment}  м.</span></label>
      </div>
    );
  } else {
    return null;
  }
}

export default ShowLengthCable;